import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MomMinutesOfMeetingService } from 'src/app/services/mom-minutes-of-meeting.service';

@Component({
  selector: 'app-mom-start-meeting',
  templateUrl: './mom-start-meeting.component.html',
  styleUrls: ['./mom-start-meeting.component.scss']
})
export class MomStartMeetingComponent implements OnInit {

  meetingList:any
  meetingId:number = 0
  mediaUrl: string = '';
  constructor(private dialog: MatDialog, private router: Router, private momMinutesOfMeetingService: MomMinutesOfMeetingService) { }

  ngOnInit() {
    this.getAllMeetings()
  }


  getAllMeetings(){
    this.momMinutesOfMeetingService.getMeetingsByStatus('SCHEDULED')//getMethod('meetingsByStatus/SCHEDULED')
    .subscribe((res:any)=>{
      this.meetingList = res
      this.mediaUrl = res && res.length > 0 ? res[0]?.mediaUrl : ''; 
    })
  }

  openConfirmationDialog(templateRef: TemplateRef<any>, id:number){
    this.meetingId = id
    this.dialog.open(templateRef,{
      width: '35%',
      // height: '15%',
      hasBackdrop: false
    })
  }

  goToRecordMeeting(){
    sessionStorage.setItem('startTime', String(new Date().toISOString()))
    this.router.navigate(['/secure/mom-meeting/start-meeting/record', {mode: 'record', id: this.meetingId}])
    this.dialog.closeAll()
  }

  downloadPdf(url:string, fileName:string){
    this.momMinutesOfMeetingService.downloadFile(url, fileName)
  }

  download(url:string){
    var link=document.createElement('a');
    link.href = url;
    link.download = url.substr(url.lastIndexOf('/') + 1);
    link.click();
  }
}
